import cookieConsent from 'cvent-cookieconsent';
// eslint-disable-next-line no-unused-vars
import cookieConsentGlobleStyles from 'cvent-cookieconsent/build/cookieconsent.min.css';
import { getPrivacyPolicyLink } from 'event-widgets/utils/privacyPolicyUtils';
import { shouldShowCookieBanner, shouldShowCookieBannerLink, getComplianceSettings, getCookieBannerSettings }
  from 'event-widgets/redux/selectors/complianceSettings';

export default function showCookieConsent(state) {
  if (!state.event || !getComplianceSettings(state) || !getCookieBannerSettings(state) ||
    !state.text || !state.text.translate || typeof state.text.translate !== 'function') {
    return;
  }
  const eventId = state.event.id;
  const enabled = shouldShowCookieBanner(state) &&
    !state.userSession.isPlanner;
  const showLink = shouldShowCookieBannerLink(state);
  const language = state.event.languageId || state.event.cultureCode;
  const translate = state.text.translate;

  if (enabled) {
    cookieConsent({
      showLink,
      cookie: { identifier: eventId },
      language,
      content: {
        message: translate('EventGuestSide_CookieConsent_Text__resx'),
        link: translate('EventGuestSide_CookieConsent_PrivacyPolicy__resx'),
        dismiss: translate('EventGuestSide_CookieConsent_Dismiss__resx'),
        href: getPrivacyPolicyLink(language, 'cookies')
      },
      elements: {
        messagelink: '<span id="cookieconsent:desc" class="cc-message">{{message}}<br /><a aria-label="' +
          translate('EventGuestSide_CookieConsent_PrivacyPolicyLink_ARIA__resx') + ' role=button tabindex="0" ' +
          'class="cc-link" href="{{href}}" rel="noopener nofollow" target="_blank">{{link}}</a></span>'
      }
    });
  }
}
